var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAlertClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 36,
  height: 36,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m24.288 9.517-6.364 6.363-6.364-6.363-2.12 2.12 6.363 6.364-6.364 6.363 2.121 2.12 6.364-6.362 6.364 6.363 2.121-2.121L20.046 18l6.363-6.363-2.121-2.121Z",
  fill: "#A9B0BB"
})));
export { SvgAlertClose as ReactComponent };
export default __webpack_public_path__ + "442932db26fca54747c2f8eb00bd1160.svg";